import { Pipe, type PipeTransform } from '@angular/core';

@Pipe({
  name: 'removeHTMLTag',
  standalone: true,
  pure: true,
})
export class RemoveHTMLTagPipe implements PipeTransform {
  readonly domParserSupportedType: DOMParserSupportedType = 'text/html';

  transform(value = ''): string {
    const parser = new DOMParser();
    const doc = parser.parseFromString(value, this.domParserSupportedType);
    const textContent = doc.body.textContent || '';

    return textContent.trim();
  }
}
